<template>
  <div class="p-4" v-if="isReady"> <!-- Added padding to the main container -->
    <h4 class="font-bold">Main driver's details</h4>
    <p class="mt-4">As they appear on driving licence</p>


    <div class="vx-row my-8">
      <!-- First name and Last name in same row on larger devices -->
      <div class="w-full md:flex md:space-x-4">
        <!-- First name  -->
        <div class="w-full md:w-2/12 p-2"> <!-- Added padding to the input container -->
          <label class="formLabel">Title</label>
          <v-select v-validate="'required'" :reduce="titleOptions => titleOptions.id" class="w-full" name="title"
            v-model="driverInfo.title" :options="titleOptions" />
          <span class="text-danger text-sm" v-show="errors.has('title')">
            {{ errors.first("title") }}
          </span>
        </div>

        <div class="w-full md:w-4/12 p-2">
          <label class="formLabel">First Name</label>
          <vs-input v-validate="'required|alpha_spaces'" class="w-full" name="First Name"
            v-model="driverInfo.clientName" @blur="validate" />
          <span class="text-danger text-sm" v-show="errors.has('First Name')">
            {{ errors.first("First Name") }}
          </span>
        </div>

        <!-- Last name  -->
        <div class="w-full md:w-4/12 p-2 mt-5 md:mt-0">
          <label class="formLabel">Surname</label>
          <vs-input v-validate="'required|alpha_spaces'" class="w-full" name="Surname"
            v-model="driverInfo.clientSurname" @blur="validate" />
          <span class="text-danger text-sm" v-show="errors.has('Surname')">
            {{ errors.first("Surname") }}
          </span>
        </div>

        <div class="w-full md:w-2/12 p-2"> <!-- Added padding to the input container -->
          <label class="formLabel">Gender</label>
          <v-select :reduce="genderOptions => genderOptions.id" v-validate="'required'" class="w-full" name="Gender"
            v-model="driverInfo.gender" :options="genderOptions" />
          <span class="text-danger text-sm" v-show="errors.has('Gender')">
            {{ errors.first("Gender") }}
          </span>
        </div>

      </div>
      <div class="w-full md:w-6/12 p-2">
        <label class="formLabel">Date Of Birth</label>
        <div class="flex space-x-2">
          <v-select :reduce="dayOptions => dayOptions.id" v-validate="'required'" class="w-1/3" name="Birth Day"
            v-model="selectedDay" :options="dayOptions" placeholder="Day" />
          <v-select :reduce="monthOptions => monthOptions.id" v-validate="'required'" class="w-1/3" name="Birth Month"
            v-model="selectedMonth" :options="monthOptions" placeholder="Month" />
          <v-select :reduce="yearOptions => yearOptions.id" v-validate="'required'" class="w-1/3" name="Birth Year"
            v-model="selectedYear" :options="yearOptions" placeholder="Year" />
        </div>
        <span class="text-danger text-sm" v-show="errors.has('Birth Day')">
          {{ errors.first("Birth Day") }}
        </span>
        <span class="text-danger text-sm" v-show="errors.has('Birth Month')">
          {{ errors.first("Birth Month") }}
        </span>
        <span class="text-danger text-sm" v-show="errors.has('Birth Year')">
          {{ errors.first("Birth Year") }}
        </span>
      </div>
      <div class="w-full md:w-6/12 p-2"> <!-- Added padding to the input container -->
        <label class="formLabel">Nationality</label>
        <v-select :reduce="nationality => nationality.id" v-validate="'required'" class="w-full" name="Nationality"
          v-model="driverInfo.country" :options="nationality" />
        <span class="text-danger text-sm" v-show="errors.has('Nationality')">
          {{ errors.first("Nationality") }}
        </span>
      </div>

      <!-- Email  -->
      <div class="w-full md:w-6/12 p-2 mt-5"> <!-- Added padding to the input container -->
        <label class="formLabel">Email</label>
        <vs-input v-validate="'required|email'" class="w-full" name="Email" v-model="driverInfo.clientEmail"
          @blur="validate" />
        <span class="text-danger text-sm" v-show="errors.has('Email')">
          {{ errors.first("Email") }}
        </span>
      </div>
      <div class="w-full md:w-6/12 p-2 mt-5"> <!-- Added padding to the input container -->
        <label class="formLabel">Confirm Email</label>
        <vs-input v-validate="'required|email|confirmed:' + driverInfo.clientEmail" class="w-full" name="Confirm Email"
          v-model="driverInfo.clientConfirmEmail" @blur="validate" />
        <span class="text-danger text-sm" v-show="errors.has('Confirm Email')">
          {{ errors.first("Confirm Email") }}
        </span>
      </div>

      <!-- Contact number  -->
      <div class="w-full md:w-6/12 p-2 mt-5"> <!-- Added padding to the input container -->
        <label class="formLabel"> Mobile Phone </label>
        <div class="flex space-x-2">
          <v-select :reduce="mobilePrefix => mobilePrefix.id" v-validate="'required'" class="w-1/3" name="Phone Prefix"
            v-model="driverInfo.phonePrefix" :options="mobilePrefix" />
          <vs-input v-model="partialPhone" v-validate="'required|numeric|min:10'" class="w-2/3" name="Mobile Phone"
            @blur="validate" />
        </div>
        <span class="text-danger text-sm" v-show="errors.has('Mobile Phone')">
          {{ errors.first("Phone Prefix") }}
        </span>
        <span class="text-danger text-sm" v-show="errors.has('Phone Prefix')">
          {{ errors.first("Phone Prefix") }}
        </span>
      </div>

      <!-- Driver's license number  -->
      <div class="w-full md:w-4/12 p-2 mt-6"> <!-- Added padding to the input container -->
        <label class="formLabel">Driver's license number</label>
        <vs-input v-validate="'required'" class="w-full" name="Drivers license" v-model="driverInfo.clientDrLicense"
          @blur="validate" />
        <span class="text-danger text-sm" v-show="errors.has('Drivers license')">
          {{ errors.first("Drivers license") }}
        </span>
      </div>
      <div class="w-full md:w-2/12 p-2 mt-6"> <!-- Added padding to the input container -->
        <label class="formLabel">Issuing Country</label>
        <v-select :reduce="countries => countries.id" v-validate="'required'" class="w-full" name="IssuingCountry"
          v-model="driverInfo.issueingCountry" :options="countries" />
        <span class="text-danger text-sm" v-show="errors.has('IssuingCountry')">
          {{ errors.first("IssuingCountry") }}
        </span>
      </div>
      <div class="w-full  p-2 mt-6"> <!-- Added padding to the input container -->
        <label class="formLabel">Delivery Address / Instruction's</label>

        <vs-textarea v-model="driverInfo.remarks" class="w-full"></vs-textarea>

      </div>
    </div>

    <div v-if="showflightDetails">
      <h4 class="font-bold">Flight Details</h4>
      <div class="w-full md:flex md:space-x-4">
        <div class="w-full md:w-6/12 p-2"> <!-- Added padding to the input container -->
          <label class="formLabel">Flight Number</label>
          <vs-input v-validate="'required'" class="w-full" name="flightNumber" v-model="driverInfo.flightArrivalNumber"
            @blur="validate" />
          <span class="text-danger text-sm" v-show="errors.has('flightNumber')">
            Flight Number is required
          </span>
        </div>
        <div class="w-full md:w-6/12 p-2 mt-5 md:mt-0"> <!-- Added padding to the input container -->
          <label class="formLabel">Flight Date</label><br>
          <flat-pickr name="arrival_Date" v-validate="'required'" :config="configdateTimePicker"
            v-model="driverInfo.clientArrivalDate" placeholder="Date Time" />
          <br>
          <span class="text-danger text-sm" v-show="errors.has('arrival_Date')">
            Arrival Date is Invalid
          </span>
        </div>
      </div>

    </div>
    <!-- <pre>{{ driverInfo }}</pre> -->

    <!-- <br>
    $store.state.main.reservationData ::
    <pre>{{ this.$store.state.main.reservationDataFromDb }}</pre> -->
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mobilePrefix } from './mobilePrefix';
import { countries } from './countries';
import { Validator } from 'vee-validate';

import { axiosMixin } from "@/mixin/axiosMixin";
export default {
  mixins: [axiosMixin],
  data() {
    return {
      isReady: false,
      driverInfo: {
        clientName: "",
        clientSurname: "",
        clientMobile: "",
        clientEmail: "",
        clientDrLicense: "",
        clientArrivalDate: "",
        flightArrivalNumber: "",
        phonePrefix: "",
        title: "",
        gender: "",
        country: "",
        issueingCountry: "",
        remarks: "",
        clientDob: "",
        clientConfirmEmail: "",
      },
      partialPhone: '',
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'd-m-Y H:i'
      },
      titleOptions: [
        { id: 'Miss', label: 'Miss' },
        { id: 'Mr', label: 'Mr' },
        { id: 'Mrs', label: 'Mrs' },
      ],
      genderOptions: [
        { id: 'Female', label: 'Female' },
        { id: 'Male', label: 'Male' },

      ],
      mobilePrefix,
      countries,
      selectedDay: '',
      selectedMonth: '',
      selectedYear: '',
      dayOptions: Array.from({ length: 31 }, (v, k) => ({
        id: String(k + 1).padStart(2, '0'),
        label: String(k + 1).padStart(2, '0'),
      })),
      monthOptions: [
        { id: '01', label: 'January' },
        { id: '02', label: 'February' },
        { id: '03', label: 'March' },
        { id: '04', label: 'April' },
        { id: '05', label: 'May' },
        { id: '06', label: 'June' },
        { id: '07', label: 'July' },
        { id: '08', label: 'August' },
        { id: '09', label: 'September' },
        { id: '10', label: 'October' },
        { id: '11', label: 'November' },
        { id: '12', label: 'December' },
      ],
      yearOptions: this.generateYearOptions(),
    };
  },
  watch: {
    selectedDay(newVal, oldVal) {
      this.updateClientDob();
    },
    selectedMonth(newVal, oldVal) {
      this.updateClientDob();
    },
    selectedYear(newVal, oldVal) {
      this.updateClientDob();
    },
    'driverInfo.phonePrefix'(newPrefix) {
      this.combinePhoneNumber();
    },
    'partialPhone'(newMobile) {
      this.combinePhoneNumber();
    },
    driverInfo: {
      deep: true,
      handler(newVal) {
        this.$store.state.main.bookingDetails.driverInfo = newVal;
      },
    },
  },
  computed: {
    showflightDetails() {
      return this.$store.state.main.bookingDetails.isAirportCharge;
    },
    nationality() {
      return this.$store.state.main.nationalities;
    }
  },
  methods: {
    validate() {
      this.$validator.validateAll();
    },
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 25;
      const endYear = currentYear - 75;
      const years = [];
      for (let i = startYear; i >= endYear; i--) {
        years.push({ id: String(i), label: String(i) });
      }
      return years;
    },
    combinePhoneNumber() {
      if (this.driverInfo.phonePrefix && this.partialPhone) {
        // Combine prefix and partialPhone into clientMobile
        this.driverInfo.clientMobile = `${this.driverInfo.phonePrefix}${this.partialPhone}`;
      } else {
        this.driverInfo.clientMobile = ''; // Clear clientMobile if inputs are not complete
      }
    },
    updateClientDob() {
      const year = this.selectedYear || '';
      const month = this.selectedMonth || '';
      const day = this.selectedDay || '';

      if (year && month && day) {
        this.driverInfo.clientDob = `${year}-${month}-${day}`;
      } else {
        this.driverInfo.clientDob = '';
      }

    }
  },
  components: {
    vSelect,
    flatPickr
  },
  mounted() {
    // Set the driverInfo object to the reservationData if it exists under Client
    if (this.$store.state.main.reservationData.Client) {

      //map clientName to Name, clientSurname to Surname, clientMobile to Mobile, clientEmail to Email, clientDrLicense to DrLicense
      this.driverInfo.clientName = this.$store.state.main.reservationData.Client.Name;
      this.driverInfo.clientSurname = this.$store.state.main.reservationData.Client.Surname;

      //from db
      var dbData = this.$store.state.main.reservationDataFromDb;
      this.driverInfo.clientEmail = dbData.ClientEmail;
      this.driverInfo.clientConfirmEmail = dbData.ClientEmail;
      this.driverInfo.gender = dbData.ClientGender;
      this.driverInfo.selectedDay = dbData.ClientGender;
      this.driverInfo.clientDrLicense = dbData.ClientDrLicense;
      this.partialPhone = dbData.ClientMobile;

      //break down the dob to day, month and year
      var dob = dbData.ClientDOB.split('-');
      this.selectedDay = dob[2];
      this.selectedMonth = dob[1];
      this.selectedYear = dob[0];

    }
    this.isReady = true;
  },
  created() {
    Validator.extend('confirmed', {
      getMessage: (field, [target]) => `${field} does not match.`,
      validate: (value, [target]) => {
        return value === target;
      },
      params: ['target']
    });
  },
};
</script>
<style>
.formLabel {
  font-size: 16px;
  font-weight: bold;
}
</style>
